(function () {
    'use strict';

    angular.module('processModule')
        .config(['$stateProvider', '$urlRouterProvider', routesConfig]);

    function routesConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('areas-root-view', {
                url: '/process-fe/home/root-details',
                params: {},
                templateUrl: 'app/process/areas-root-view/areas-root-view.html',
                controller: 'areas-root-view.controller',
                controllerAs: 'vm',
                data: {
                    title: 'Process Home',
                    description: 'Process Home'
                }
            })
            .state('process-area-detail', {
                url: '/process-fe/area/detail/:areaId',
                params: { areaId: '0' },
                templateUrl: 'app/process/area-detail/area-detail.html',
                controller: 'area-detail.controller',
                controllerAs: 'vm',
                data: {
                    title: 'Area detail',
                    description: 'Area detail'
                }
            })
            .state('process-detail', {
                url: '/process-fe/process-detail/:processNumber',
                params: { processNumber: 0 },
                templateUrl: 'app/process/process-detail-view/process-detail-view.html',
                controller: 'process-detail-view.controller',
                controllerAs: 'vm',
                data: {
                    title: 'Process detail',
                    description: 'Process detail'
                }
            })
            .state('process-interconnected', {
                url: '/process-fe/process-interconnected/:processNumber',
                params: { processNumber: 0 },
                templateUrl: 'app/process/process-interconnected-view/process-interconnected-view.html',
                controller: 'process-interconnected-view.controller',
                controllerAs: 'vm',
                data: {
                    title: 'Process Interconnected',
                    description: 'Process Interconnected'
                }
            })
            .state('process-hearing-view', {
                url: '/process-fe/process-detail/viewsendtohearing/:processNumber/:version',
                params: { processNumber: '0', version: '' },
                templateUrl: 'app/process/process-hearing-view/process-hearing-view.html',
                controller: 'process-hearing-view.controller',
                controllerAs: 'vm',
                data: {
                    title: 'Process hearing',
                    description: 'Process hearing'
                }
            })
            .state('process-interconnected-hearing-view', {
                url: '/process-fe/process-interconnected/viewsendtohearing/:processNumber/:version',
                params: { processNumber: '0', version: '' },
                templateUrl: 'app/process/process-interconnected-hearing-view/process-interconnected-hearing-view.html',
                controller: 'process-interconnected-hearing-view.controller',
                controllerAs: 'vm',
                data: {
                    title: 'Interconnected hearing',
                    description: 'Interconnected hearing'
                }
            });
        $urlRouterProvider.otherwise('/');
    };
})();